import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";

export const TagsContainer = ({ tagsData,}) => {
    return (
        <div className="tags-container">
            {tagsData?.map((tag, id) => (
                <button
                    className="tag-button"
                    key={id}
                    disabled
                >
                    <FontAwesomeIcon icon={faCircleCheck} className="tag-chk" />
                    <span className="tag-nm">{tag}</span>
                </button>
            ))}
        </div>
    )
}